var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2366 0.00015602H2.13401C0.96559 0.00015602 0.0234375 0.934882 0.0234375 2.10334V11.1467C0.0234375 12.3115 0.96559 13.2425 2.13401 13.2425H2.47156V16.3694C2.47156 16.6179 2.61993 16.8442 2.8462 16.9444C2.92781 16.9815 3.01683 17 3.10215 17C3.25423 17 3.40631 16.9332 3.52501 16.8294L7.47527 13.2423H16.2402C17.405 13.2423 18.3508 12.3113 18.3508 11.1466V2.10318C18.3471 0.93476 17.4049 0 16.2365 0L16.2366 0.00015602ZM17.0861 11.1465C17.0861 11.6176 16.7077 11.9811 16.2366 11.9811H7.23055C7.07475 11.9811 6.92267 12.0479 6.80768 12.1517L3.73267 14.9486V12.6303C3.73267 12.2816 3.45076 11.9811 3.10208 11.9811H2.13395C1.66285 11.9811 1.28451 11.6176 1.28451 11.1465V2.10314C1.28451 1.63205 1.66285 1.26114 2.13395 1.26114H16.2403C16.7114 1.26114 17.0897 1.63208 17.0897 2.10314V11.1465L17.0861 11.1465Z",
    fill: "#BF1E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8448 8.23438H4.52707C4.17841 8.23438 3.89648 8.51628 3.89648 8.86496C3.89648 9.21365 4.17839 9.49555 4.52707 9.49555H13.8411C14.1898 9.49555 14.4717 9.21365 14.4717 8.86496C14.4717 8.51628 14.1935 8.23438 13.8448 8.23438Z",
    fill: "#BF1E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8448 5.78516H4.52707C4.17841 5.78516 3.89648 6.06706 3.89648 6.41575C3.89648 6.76443 4.17839 7.04633 4.52707 7.04633H13.8411C14.1898 7.04633 14.4717 6.76443 14.4717 6.41575C14.4717 6.06706 14.1935 5.78516 13.8448 5.78516Z",
    fill: "#BF1E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52707 4.56977H8.08427C8.43293 4.56977 8.71486 4.28787 8.71486 3.93918C8.71486 3.5905 8.43295 3.30859 8.08427 3.30859H4.52707C4.17841 3.30859 3.89648 3.5905 3.89648 3.93918C3.89648 4.28787 4.17839 4.56977 4.52707 4.56977Z",
    fill: "#BF1E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgicon);
export default __webpack_public_path__ + "static/media/msgicon.202c80d0685b534513daad719680b6fb.svg";
export { ForwardRef as ReactComponent };